// Official MOBIX logo (inline SVG, transparent background).
// Pass `mono` to render a single-color version (uses currentColor) e.g. on dark surfaces.
export const Logo = ({ className = "", mono = false, title = "MOBIX" }) => {
  const fills = mono
    ? {
        navyDark: "currentColor",
        navy: "currentColor",
        mauve: "currentColor",
        mauve2: "currentColor",
        cream: "currentColor",
        orange: "currentColor",
      }
    : {
        navyDark: "#0F3059",
        navy: "#10315A",
        mauve: "#827588",
        mauve2: "#827589",
        cream: "#D5B698",
        orange: "#EA712D",
      };

  return (
    <svg
      viewBox="0 0 2048 512"
      role="img"
      aria-label={title}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path transform="translate(141,98)" d="m0 0h44l8 4 10 11 9 12 12 14 13 17 12 14 11 14 9 11 14 17 10 13 12 14 10 13 14 17 7 9 5-5 11-14 10-13 9-11 9-12 13-16 8-11 9-11 13-17 13-16 8-11 13-16 9-12 9-11 5-4h45l6 3 3 4 1 3v321l-3 7-6 3h-40l-7-6-2-18v-188l1-29-5 5-11 13-4 6-13 16-8 11-9 11-8 10-8 11-14 17-8 11-13 16-8 11-18 22-5 6-7 3h-7l-7-3-12-14-9-12-11-13-9-11-6-8-11-13-11-14-8-10-11-13-10-13-14-17-12-15-9-11-2-3-1 234-3 5-5 3h-40l-5-3-3-4v-327l5-5z" fill={fills.navyDark} />
      <path transform="translate(1045,99)" d="m0 0h194l26 4 12 4 11 6 12 9 11 11 10 16 6 14 3 12 1 7v22l-3 16-6 16-8 13-9 10-4 5 10 8 12 12 7 11 7 15 4 14 1 5v28l-6 23-8 15-9 12-9 9-11 7-15 8-10 3-25 3h-203l-11-3-3-4v-324l5-5zm44 53v88l2 1 151-1 14-7 8-7 6-10 4-11 1-10-3-14-5-10-6-8-12-8-9-3zm0 141v90h158l13-5 9-6 7-7 5-8 3-10v-18l-4-11-6-9-9-8-12-6-9-2z" fill={fills.navy} />
      <path transform="translate(772,90)" d="m0 0h33l21 3 22 6 20 9 15 8 14 10 14 12 11 11 9 11 12 18 8 16 6 14 4 13 5 25 1 14v16l-2 21-5 21-7 20-10 20-13 19-10 11-7 8-12 11-24 16-23 11-18 6-24 5-12 1h-19v-2l8-6 8-8 11-16 7-15 6-20 15-6 17-9 13-10 10-10 10-14 9-17 5-15 3-13 1-11v-12l-1-11-5-20-7-16-6-11-9-12-14-14-15-10-14-7-19-6-13-2h-26l-17 3-16 6-14 7-11 8-10 9-8 8-9 13-8 16-5 13-3 17-1 11-8 5-11 7-12 11-7 7-9 13-7 13-2-2-4-15-2-16-1-2v-34l1-2 3-21 6-20 7-17 9-17 11-15 7-9 9-10 8-7 17-13 13-8 16-8 16-6 17-5z" fill={fills.mauve} />
      <path transform="translate(1575,96)" d="m0 0h45l8 5 9 10 9 11 13 16 12 14 11 14 12 14 9 11 13 16 22 26 6 8 12 14 6 8-1 6-10 11-9 11-8 10-22 26-5 7h-2l-2 5-9 10-27 33-12 14-8 10-9 11-10 12-7 4h-69l-1-5 6-8 13-15 11-14 13-15 18-22 11-13 12-14 11-14 24-28 6-8 10-12-2-4-7-9-24-28-7-9-24-28-7-9-13-15-11-13-8-10-24-28-8-10 1-5z" fill={fills.mauve2} />
      <path transform="translate(1420,94)" d="m0 0h40l5 3 2 3 1 44v222l-1 63-5 5-11 1h-26l-9-2-4-5-1-3v-322l3-5 3-3z" fill={fills.navyDark} />
      <path transform="translate(707,291)" d="m0 0h19l14 3 16 8 10 9 7 7 8 14 4 11 2 14v9l-2 13-5 14-9 13-10 10-12 8-14 5-9 2h-19l-16-4-13-7-11-9-8-9-6-10-5-14-2-10v-15l5-19 8-14 11-12 11-8 10-5z" fill={fills.cream} />
      <path transform="translate(1771,275)" d="m0 0 5 1 10 12 9 11 13 15 11 14 13 15 11 13 11 14 9 10 9 11 10 12 9 11 11 13v5l-1 1-35 1h-31l-8-3-11-12-10-13-12-14-9-11-11-14-13-15-10-13-8-10v-15l8-11 13-19z" fill={fills.orange} />
      <path transform="translate(1834,95)" d="m0 0 67 1 1 5-6 8-12 14-10 12-9 11-11 13-12 14-7 9-12 14-11 13-7 9-12 14-11 13-6 8-5 1-10-13-7-11-8-11-3-5v-14l6-8 11-13 9-11 11-14 12-14 13-16 8-10 12-14 6-4z" fill={fills.orange} />
    </svg>
  );
};

export default Logo;
